<script lang="ts">
    import { isDarkMode } from "../../store";
    // darkmode value change
    let darkmode:boolean
    isDarkMode.subscribe((value)=>{
        darkmode = value
    })
    function toggle() {
        isDarkMode.update(value => value = !value) 
    }
</script>
<li>
    <!-- svelte-ignore a11y-click-events-have-key-events -->
    <div class="mode" on:click={toggle} >
        {#if darkmode}    
            <i class="fa fa-lightbulb-o"></i>
        {:else}
            <i class="fa fa-moon-o"></i>
        {/if}
    </div>
</li>
